// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__1a2HX","message":"style_message__MfZR1","timer":"style_timer__2Ua55","mymove":"style_mymove__2UQJw","mymoveRight":"style_mymoveRight__2nSqY"};